import {Button, Container, Group, Stack, Title} from "@mantine/core";
import {Link, useNavigate} from "@tanstack/react-router";
import {BatchEntryForm, useCreateLibraryEntry} from "@/app/library";
import type {LibraryEntry} from "@/shared/types";

export function LibraryNewPage() {
  const navigate = useNavigate();
  const createMutation = useCreateLibraryEntry();

  const handleBatchSubmit = async (
    entries: Omit<LibraryEntry, "createdAt" | "updatedAt">[],
  ) => {
    try {
      // For now, create them one by one
      // In the future, we might want a batch creation method in the client
      for (const entry of entries) {
        await createMutation.mutateAsync(entry);
      }
      navigate({to: "/library"});
    } catch (error) {
      console.error("Error importing batch", error);
      alert("Error importing batch. Check console for details.");
    }
  };

  return (
    <Container size="sm" py="xl">
      <Stack gap="lg">
        <Group justify="space-between">
          <Title order={2}>New Batch Entry</Title>
          <Button variant="subtle" component={Link} to="/library">
            Back to Library
          </Button>
        </Group>

        <BatchEntryForm onSubmit={handleBatchSubmit} loading={createMutation.isPending} />
      </Stack>
    </Container>
  );
}
